import { formatDigestFirstBookAmount } from "@/features/bookings/lclFirstBookOpportunity";
import type { BookingOpportunityPayload } from "@/types/feed";

/** Whether a payload is a per-booking opportunity root. */
export function isBookingOpportunityPayload(
  payload: unknown,
): payload is BookingOpportunityPayload {
  if (!payload || typeof payload !== "object") return false;
  const p = payload as Record<string, unknown>;
  return p.kind === "booking_opportunity" && !!p.booking;
}

/**
 * Derive a first-book opportunity title with correct LCL W/M quoting when the
 * stored title still carries a `$0` placeholder.
 */
export function bookingOpportunityDisplayTitle(event: {
  title: string;
  payload?: unknown;
}): string | null {
  if (!isBookingOpportunityPayload(event.payload)) return null;
  const payload = event.payload;
  if (payload.dimension !== "first_book") return null;

  const booking = payload.booking;
  const hasLclQuote =
    booking.lcl_pricing_mode === "quote_per_wm" &&
    booking.lcl_frt_per_wm != null &&
    booking.lcl_frt_per_wm > 0;
  const hasTotalQuote =
    booking.first_book_price != null && booking.first_book_price > 0;
  if (!hasLclQuote && !hasTotalQuote) return null;

  const sourceId = booking.source_id;
  const carrier = booking.alternative_carrier?.trim();
  const priceLabel = formatDigestFirstBookAmount(booking);

  if (carrier && priceLabel) {
    return `First book ${sourceId} · ${carrier} · ${priceLabel}`;
  }
  if (carrier) return `First book ${sourceId} · ${carrier}`;
  if (priceLabel) return `First book ${sourceId} · ${priceLabel}`;
  return `First book ${sourceId}`;
}
